import {Card, Col, Form, Input, Radio, Row, Space} from 'antd'
import React from 'react'
import '../../asset/less/component.css'
import PropTypes from "prop-types";
import Title from "antd/es/typography/Title";

const PublicSettingsExhibition = (props) => {
    return (
        <>
            <Row>
                <Col style={{paddingTop: 48, marginLeft: 'auto', marginRight: 'auto'}} span={24}>
                    <Card bordered={false} style={{width: '100%'}}>
                        <div style={{padding: 12}}>
                            <Radio.Group onChange={props.onSelectPublicChange} value={props.is_publish}>
                                <Title level={4}>Who can see your exhibition page?</Title>
                                <Space direction='vertical' style={{marginTop: 12}}>
                                    <Radio value={true}>Shared on RevArt and search engines</Radio>
                                    <Radio value={false}>Only available to you</Radio>
                                </Space>
                            </Radio.Group>
                        </div>
                    </Card>
                </Col>
            </Row>
            <Row>
                <Col style={{paddingTop: 12, marginLeft: 'auto', marginRight: 'auto'}} span={24}>
                    <Card bordered={false} style={{width: '100%'}}>
                        <div style={{padding: 12}}>
                            <Form.Item name='gallery_name' label='Gallery Name'
                                       style={{width: '100%', minWidth: 260, maxWidth: 540}} rules={[
                                {
                                    maxLength: 100,
                                    message: 'maximum length is 100'
                                }
                            ]}>
                                <Input defaultValue={props.gallery_name?? ''}/>
                            </Form.Item>
                        </div>
                    </Card>
                </Col>
            </Row>
        </>
    )
}

// Setting default values for the props of AddExhibitionArtwork
PublicSettingsExhibition.defaultProps = {
    initTargetKeys: [],
    role: 'artist',
    cancelToken: null
};

// Typechecking props for the AddExhibitionArtwork
PublicSettingsExhibition.propTypes = {
    initTargetKeys: PropTypes.array,
    artistId: PropTypes.string,
    role: PropTypes.string,
    cancelToken: PropTypes.any,
    onTargetKeysChange: PropTypes.func
}

export default PublicSettingsExhibition;